export const japanPhotoInformation = {
  tokyo_potato: {
    date: "2023-04-17",
    location: "Ginza, Tokyo",
    description: [
      "The sweetest sweet potato I've ever had. Roasted inside these big clay pots.",
    ],
  },
  tokyo_ramen: {
    date: "2023-04-27",
    location: "Ginza Hachigo, Tokyo",
    description: [
      "Waited in line for like 2.5 hours for this Michelin starred ramen. Worth it for the experience.",
    ],
  },
  tokyo_park: {
    date: "2023-04-27",
    location: "Chibiya Park, Chiyoda, Tokyo",
    description: ["Reminded me of that movie, The Garden of Words"],
  },
  tokyo_tonkatsu: {
    date: "2023-04-27",
    location: "Tonkatsu Aoki, Tokyo",
    description: ["That's tonkatsu alright"],
  },
  tokyo_matcha: {
    date: "2023-04-27",
    location: "Suzukien Asakusa, Tokyo",
    description: ["Only got the second strongest matcha"],
  },

  osaka_capitalism: {
    date: "2023-04-18",
    location: "Dotonburi, Osaka",
    description: ["Lots of capitalism."],
  },

  kyoto_knife: {
    date: "2023-04-18",
    location: "Hayakawa Hamonoten, Kyoto",
    description: [
      "Bought a nakiri knife from this shop and got it engraved with my last name. The man running the shop was so kind, gave me cookies and an umbrella because it started raining while I was in there 🥺",
    ],
  },
  kyoto_ramen: {
    date: "2023-04-18",
    location: "Kyoto",
    description: ["One of many ramen bowls this trip."],
  },
  kyoto_soba: {
    date: "2023-04-18",
    location: "Honke Owariya, Kyoto",
    description: ["Soba set. Duck soba, as usual."],
  },
  kyoto_soba: {
    date: "2023-04-19",
    location: "Honke Owariya, Kyoto",
    description: ["Soba set. Duck soba, as usual."],
  },
  kyoto_railway: {
    date: "2023-04-20",
    location: "Kyoto Railway Museum, Kyoto",
    description: ["I like trains."],
  },
  kyoto_arashiyama: {
    date: "2023-04-20",
    location: "Arashiyama, Kyoto",
    description: ["View upon arriving at the station by Arashiyama."],
  },
  kyoto_tofu_1: {
    date: "2023-04-20",
    location: "Shoraian, Kyoto",
    description: [
      "One part of the tofu kaiseki set.",
      "From top to bottom, left to right: veggie tofu, potato, sesame tofu, yuba skin roll, tofu skin roll, bamboo shoot, konjac, squid, sawara, mushroom with tofu",
    ],
  },
  kyoto_tofu_2: {
    date: "2023-04-20",
    location: "Shoraian, Kyoto",
    description: ["The dessert portion of the set, still tofu themed!"],
  },
  kyoto_bamboo: {
    date: "2023-04-20",
    location: "Arashiyama, Kyoto",
    description: ["Bamboo forest, hard to capture how far they stretch up."],
  },
  kyoto_unagi: {
    date: "2023-04-21",
    location: "大國屋 鰻兵衞, Kyoto",
    description: ["Closed out Kyoto with an unagi don."],
  },

  nagano_onroute: {
    date: "2023-04-21",
    location: "Kyoto → Nagano",
    description: ["View on the train from Kyoto to Nagano."],
  },
  nagano_zenkoji_1: {
    date: "2023-04-22",
    location: "Zenkoji, Nagano",
    description: ["Zenkoji temple."],
  },
  nagano_zenkoji_2: {
    date: "2023-04-22",
    location: "Zenkoji, Nagano",
    description: ["Another one of Zenkoji temple."],
  },
  nagano_monke: {
    date: "2023-04-22",
    location: "Snow Monkey Park, Nagano",
    description: [
      "Unfortunately, there were no monkes when we went to the park.",
    ],
  },
  nagano_cherry: {
    date: "2023-04-23",
    location: "Olympic Park, Nagano",
    description: [
      "Cherry blossoms we saw as we walked to the marathon finish line to keep cheering.",
    ],
  },
  nagano_race: {
    date: "2023-04-23",
    location: "Olympic Park, Nagano",
    description: ["Yay end of Nagano marathon."],
  },

  hokkai_onroute: {
    date: "2023-04-24",
    location: "Nagano → Hokkaido",
    description: ["Tonkatsu bento on route to Hokkaido."],
  },
  hokkai_sushi_guy: {
    date: "2023-04-24",
    location: "Hakodate",
    description: [
      "I'm still not really sure why they thought this guy would be a good mascot.",
    ],
  },
  hokkai_goryoku: {
    date: "2023-04-25",
    location: "Goryoku Park, Hakodate",
    description: [
      "A little late in the season, but the park was still full of cherry blossoms.",
    ],
  },
  hokkai_me: {
    date: "2023-04-25",
    location: "Goryoku Park, Hakodate",
    description: ["Still can't take proper photos."],
  },
}
